var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    attrs: {
      "rounded": "",
      "color": _vm.color,
      "dark": _vm.dark
    }
  }, [_c('v-list-item', [_vm.radioValue ? _c('v-list-item-action', [_c('v-radio', {
    attrs: {
      "value": _vm.radioValue
    }
  })], 1) : _vm._e(), _c('v-list-item-content', [_vm.canReadCompany ? _c('v-list-item-title', {
    staticClass: "text-truncate",
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.company.companyName))])]) : _c('v-list-item-title', {
    staticClass: "text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.company.companyName) + " ")]), _c('v-list-item-subtitle', {
    staticClass: "text-xs text-truncate mb-2"
  }, [_vm.company.services ? _c('span', _vm._l(_vm.company.services, function (service) {
    return _c('v-chip', {
      key: 'service-enum' + service,
      staticClass: "mr-1",
      attrs: {
        "x-small": ""
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("enums.CompanyServiceEnum.".concat(service))) + " ")]);
  }), 1) : _vm._e()]), _vm.company.addresses.length && !_vm.hideDetails ? _c('v-list-item-subtitle', {
    staticClass: "text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.company.addresses[0].street) + ", " + _vm._s(_vm.company.addresses[0].zip) + " " + _vm._s(_vm.company.addresses[0].city) + " ")]) : _vm._e(), _vm.company.contact && !_vm.hideDetails ? _c('v-list-item-subtitle', {
    staticClass: "text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.company.contact.email) + " ")]) : _vm._e(), _vm.company.contact && !_vm.hideDetails ? _c('v-list-item-subtitle', {
    staticClass: "text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.company.contact.phone) + " ")]) : _vm._e()], 1), _vm.clearable && _vm.canUpdateCompany ? _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('v-icon', [_vm._v(" mdi-trash-can-outline ")])], 1), _c('div')], 1) : _vm._e()], 1), _vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }